import {configureStore} from "@reduxjs/toolkit";
// import gameModeReducer from "./(pages)/components/gameModeSlice";
import unityBarReducer from "@/app/(game)/unity-game/unityBarSlice";
import mainReducer from "@/app/MainSlice";
import shopItemsReducer from "./(pages)/shopItemsSlice";
import accountInfoReducer from "./(pages)/account/accountSlice";

export const store = configureStore({
    reducer: {
        // gameMode: gameModeReducer,
        unityBar: unityBarReducer,
        mainState: mainReducer,
        shopItems: shopItemsReducer,
        accountInfo: accountInfoReducer,
    }
})

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
